import * as React from 'react';
import styles from './index.less';
import FDrawer from '@/components/FDrawer';
// import FGraph_Tree_Dependency_Resource from '@/components/FAntvG6/FGraph_Tree_Dependency_Resource';
import FGraph_Tree_Authorization_Resource from '@/components/FAntvG6/FGraph_Tree_Authorization_Resource';
import * as ReactDOM from 'react-dom/client';

interface fGraphTree_Authorization_Resource_Props {
  resourceID: string;
  version: string;
}

function fGraphTree_Authorization_Resource({
  resourceID,
  version,
}: fGraphTree_Authorization_Resource_Props): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <Temp
        resourceID={resourceID}
        version={version}
        onClose={() => {
          resolve(true);
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 300);
        }}
      />,
    );
  });
}

export default fGraphTree_Authorization_Resource;

interface TempProps {
  resourceID: string;
  version: string;

  onClose?(): void;
}

function Temp({ resourceID, version, onClose }: TempProps) {
  const [visible, set_visible] = React.useState<boolean>(true);

  return (
    <FDrawer
      open={visible}
      title={'授权树'}
      destroyOnClose
      width={'100%'}
      onClose={() => {
        set_visible(false);
      }}
      afterOpenChange={(visible) => {
        if (!visible) {
          onClose && onClose();
        }
      }}
    >
      <FGraph_Tree_Authorization_Resource
        resourceID={resourceID}
        version={version}
        width={window.innerWidth - 60}
        height={window.innerHeight - 60 - 50}
      />
    </FDrawer>
  );
}
